import styled from 'styled-components'

export const ModulesContainer = styled.div`
  max-width: 1400px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
`
export const Card = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  width: 256px;
  height: 92px;
  padding: 12px;
`

export const CardDescriptionSection = styled.div`
  margin: 10px;
`
export const Icon = styled.img`
  max-width: 60px;
`

export const UploadSizeRecomended = styled.p`
  width: 174px;
  color: #797a7c;
  font-weight: 100;
  font-size: 16px;
`
export const GridDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const QuestionsTableCard = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-rows: auto auto auto;
  align-items: center;
  column-gap: 16px;
  row-gap: 16px;
  width: 100%;
  box-sizing: border-box;
  margin-top: 32px;
  padding: 20px 12px 12px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 8px 22px rgba(31, 52, 77, 0.08);

  > .skill-questions-management-table {
    grid-column: 1 / -1;
    grid-row: 3;
  }
`

export const QuestionsTableHeader = styled.div`
  display: contents;

  > a {
    grid-column: 2;
    grid-row: 1;
    display: flex;
    text-decoration: none;

    button {
      margin: 0;
    }
  }
`

export const QuestionsTableTitle = styled.h2`
  grid-column: 1;
  grid-row: 1;
  margin: 0;
  color: #163247;
  font-family: 'Public Sans', sans-serif;
  font-size: 26px;
  font-weight: 800;
  line-height: 1.2;
`

export const QuestionFilters = styled.div`
  grid-column: 1 / -1;
  grid-row: 2;
  display: grid;
  grid-template-columns: auto repeat(4, minmax(150px, 1fr)) auto auto;
  align-items: center;
  gap: 12px;

  > span {
    color: #163247;
    font-family: 'Public Sans', sans-serif;
    font-size: 0.88rem;
    font-weight: 700;
    white-space: nowrap;
  }

  .MuiFormControl-root {
    min-width: 0;
  }

  @media (max-width: 1080px) {
    grid-template-columns: auto repeat(2, minmax(180px, 1fr)) auto auto;

    > span {
      grid-row: 1;
    }
  }

  @media (max-width: 700px) {
    grid-template-columns: 1fr auto auto;

    > span {
      grid-column: 1 / -1;
    }

    .MuiFormControl-root {
      grid-column: 1 / -1;
    }
  }
`

export const FilterResetButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: transparent;
  cursor: pointer;

  &:hover {
    background: #f1f5f9;
  }
`

export const SearchButton = styled.button`
  display: flex;
  width: 52px;
  height: 48px;
  padding: 0;
  justify-content: center;
  align-items: center;
  border: 0;
  border-radius: 12px;
  color: white;
  background-color: #2d749c;
  box-shadow: 0px 8px 16px 0px rgba(112, 112, 112, 0.24);
  cursor: pointer;

  :active {
    box-shadow: 0 0px #666;
    transform: translateY(1px);
  }
`

export const MagnifyingGlass = styled.img`
  width: 20px;
  height: 20px;
`
